module.exports = __webpack_public_path__ + "img/icon-alert-triangle-outline.e4ec6016.svg";